$.ajaxSetup({
  headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

/*$('#register-step1').on('submit',function(e){
  e.preventDefault(e);
  var holder = "#" + $(this).attr('id');
  $(holder + ' button[type="submit"]').attr('disabled','disabled');

  $.ajax({
    type:"POST",
    url:'/create_entertainer',
    data:$(this).serialize(),
    dataType: 'json',
    success: function(data){
      $(holder + ' .alert').remove();
      $(holder).prepend("<div class='alert alert-success'></div>");
      $(holder + " .alert").append("<p>Entertainer was succesfully created!</p>");
    },
    error: function(data){
      $(holder + ' .alert').remove();
      $(holder).prepend("<div class='alert alert-danger'></div>");
      var dataJSON = data.responseJSON;
        $.each(dataJSON.responseText, function(a, i) {
          $(holder + " .alert").append("<p>"+ i +"</p>");
      });
      $(holder + ' button[type="submit"]').removeAttr('disabled');
    }
  })

});*/

$(".remove_video_ajax").click(function(e) {
  e.preventDefault();
  var videoId = $(this).val();
  $.ajax({
      type: "POST",
      url: "/ajax_remove_video",
      data: {"videoId":videoId},
      dataType: 'json',
      success: function(data){

      },
      error: function(data){
        alert("error");
      }
  });
});


$(".remove_specialprice_ajax").click(function(e) {
  e.preventDefault();
  var priceId = $(this).val();
  $.ajax({
      type: "POST",
      url: "/ajax_remove_specialprice",
      data: {"priceId":priceId},
      dataType: 'json',
      success: function(data){

      },
      error: function(data){
        alert("error");
      }
  });
});

$(".remove_image_ajax").click(function(e) {
  e.preventDefault();
  var div_parent = $(this).parent(); 
  var imageId = $(this).attr('imageId');
  $.ajax({
      type: "POST",
      url: "/ajax_remove_image",
      data: {"imageId":imageId},
      dataType: 'json',
      success: function(data){
        $(div_parent).remove();
      },
      error: function(data){
        alert("error");
      }
  });
});

$(".remove_custom_information").click(function(e) {
  e.preventDefault();
  var custom_infoId = $(this).val();
  $.ajax({
      type: "POST",
      url: "/ajax_remove_custom_info",
      data: {"custom_infoId":custom_infoId},
      dataType: 'json',
      success: function(data){

      },
      error: function(data){
        alert("error");
      }
  });
});

$(".remove_ajax_audio").click(function(e) {
  e.preventDefault();
  var audioId = $(this).val();
  $.ajax({
      type: "POST",
      url: "/ajax_remove_audio",
      data: {"audioId":audioId},
      dataType: 'json',
      success: function(data){

      },
      error: function(data){
        alert("error");
      }
  });
});